import { render, staticRenderFns } from "./ThankYouContent.vue?vue&type=template&id=c5d147e4&scoped=true&"
import script from "./ThankYouContent.vue?vue&type=script&lang=js&"
export * from "./ThankYouContent.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouContent.vue?vue&type=style&index=0&id=c5d147e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d147e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VProgressCircular,VRow})
